export default __webpack_public_path__ + "static/media/4-2.6bbf87c7.png";